import { render, staticRenderFns } from "./CompactMatchCard.vue?vue&type=template&id=376e20a2&scoped=true&"
import script from "./CompactMatchCard.vue?vue&type=script&lang=js&"
export * from "./CompactMatchCard.vue?vue&type=script&lang=js&"
import style0 from "./CompactMatchCard.vue?vue&type=style&index=0&id=376e20a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376e20a2",
  null
  
)

export default component.exports